import React from "react";
import { PrimaryButton, DefaultButton, Stack } from "@fluentui/react";
import { YourDetailsState } from "./CreateAccountWizard";
import { AppItem } from "./StepApps";
import { IEntity } from "../../types";
import { EditionTitles, EditionType } from "../../AppGlobals";

interface Props {
    details: YourDetailsState;
    edition: EditionType;
    apps: number[];
    allApps: AppItem[];
    customerCountries: IEntity[];
    customerSectors: IEntity[];
    onContinue: () => void;
    onBack: () => void;
}

export const StepSummary: React.FC<Props> = ({
    details,
    edition,
    apps,
    allApps,
    customerCountries,
    customerSectors,
    onContinue,
    onBack
}) => {

    const selectedApps = allApps.filter(a => apps.includes(a.id));
    const country = customerCountries.find(c => c.ID === details.country);
    const sector = customerSectors.find(s => s.ID === details.sector);

    return (
        <div className="step-summary-container">

            <h2 className="create-account-heading">Summary</h2>

            <div className="step-summary-intro">
                Please review the information you have entered before proceeding.
                If anything is incorrect you will be able to return and modify it.
            </div>

            {/* ORGANISATION */}

            <div className="step-summary-section">

                <div className="step-summary-title">
                    Organisation
                </div>

                <div className="step-summary-grid">

                    <div>
                        <strong>Name</strong>
                        <div>{details.organisationName}</div>
                    </div>

                    <div>
                        <strong>Address</strong>
                        <div>{details.address}</div>
                    </div>

                    <div>
                        <strong>Country</strong>
                        <div>{country?.Title}</div>
                    </div>

                    <div>
                        <strong>Sector</strong>
                        <div>{sector?.Title}</div>
                    </div>

                    <div>
                        <strong>Number of Staff</strong>
                        <div>{details.numberOfStaff}</div>
                    </div>

                    <div>
                        <strong>Website</strong>
                        <div>{details.website}</div>
                    </div>

                </div>

            </div>


            {/* USER */}

            <div className="step-summary-section">

                <div className="step-summary-title">
                    Your Details
                </div>

                <div className="step-summary-grid">

                    <div>
                        <strong>Name</strong>
                        <div>{details.title} {details.firstname} {details.surname}</div>
                    </div>

                    <div>
                        <strong>Email</strong>
                        <div>{details.email}</div>
                    </div>

                    <div>
                        <strong>Phone</strong>
                        <div>{details.phone}</div>
                    </div>

                </div>

            </div>


            {/* EDITION */}

            <div className="step-summary-section">

                <div className="step-summary-title">
                    Selected Edition
                </div>

                <div className="step-summary-edition">
                    {EditionTitles[edition]}
                </div>

            </div>


            {/* APPS */}

            <div className="step-summary-section">

                <div className="step-summary-title">
                    Selected Apps
                </div>

                <div className="step-summary-apps">

                    {selectedApps.map(app => (
                        <div
                            key={app.id}
                            className="step-summary-app"
                        >

                            <img
                                src={app.image}
                                alt={app.title}
                            />

                            <div>
                                {app.title}
                            </div>

                        </div>
                    ))}

                </div>

            </div>


            {/* ACTIONS */}

            <Stack horizontal tokens={{ childrenGap: 12 }} className="step-actions-btns">
                <DefaultButton text="Back" onClick={onBack} />
                <PrimaryButton text="Continue" onClick={onContinue} />
            </Stack>

        </div>
    );
};